import CustomText from "../../atomic/CustomText";
import RightArrow from "../../../assets/svg/RightArrow";

interface SectionHeaderProps {
  title: string;
  count?: number;
  onViewMore?: () => void;
  actionLabel?: string;
}

function SectionHeader({
  title,
  count = 0,
  onViewMore,
  actionLabel = "View More",
}: Readonly<SectionHeaderProps>): JSX.Element {
  return (
    <div className="flex justify-between items-center px-5 py-2 bg-[#f6f6f6] border-b border-[#d0d5dd]">
      <div className="flex gap-2 items-center">
        <CustomText
          text={title}
          fontWeight="font-normal"
          fontSize="text-xs"
          className="text-primary"
        />
        {count > 0 && (
          <div className="bg-[#F0FFFF] border border-primary rounded px-2 py-0.5">
            <CustomText
              text={count.toString()}
              fontWeight="font-normal"
              fontSize="text-xs"
              className="text-primary"
            />
          </div>
        )}
      </div>
      {count > 3 && onViewMore && (
        <button
          onClick={onViewMore}
          className="flex gap-1 items-center cursor-pointer"
          type="button"
        >
          <CustomText
            text={actionLabel}
            fontWeight="font-normal"
            fontSize="text-xs"
            className="text-primary"
          />
          <RightArrow className="w-[18px] h-[18px] [&_path]:fill-primary" />
        </button>
      )}
    </div>
  );
}

export default SectionHeader;
